import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {SetAttributeLocalizationCommand} from "./setAttributeLocalization.command";
import {mintNamespacedUid} from "../utils/uid.utils";

export class AddConstantBuildingAttribute extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (this.id === '') {
            return false;
        }

        if (state.buildingAttributes === undefined) {
            state.buildingAttributes = [];
        }

        const uid = mintNamespacedUid('buildingattribute', this.id, state.buildingAttributes.map(a => a.uid));
        new SetAttributeLocalizationCommand(uid, this.id).execute(state);

        state.buildingAttributes.push({
            uid: uid,
            id: this.id,
            active: true,
            values: {},
            entities: {}
        });
        return true;
    }
}